import { FilterConfig } from 'common/models/filter.model';
import { GLOBAL_FILTERS } from './constants';
import { FILTER_ITEMS } from './constants-filter-configs';

export const ELSIE_AI_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.categoryStatus,
  FILTER_ITEMS.alignmentChange,
  FILTER_ITEMS.insightSourceName,
  FILTER_ITEMS.tags,
];

export const ELSIE_AI_SEGMENT_FILTER: FilterConfig[] = [
  FILTER_ITEMS.alignmentScore,
  FILTER_ITEMS.accountCountry,
];
